import { CUSTOMER_ENV_BY_STAGE } from "./constants.js";

export function normalizeEmailDomain(value) {
  const normalized = String(value || "").trim().toLowerCase();
  if (!normalized) return "";
  return normalized.startsWith("@") ? normalized : `@${normalized}`;
}

export function extractEmailDomain(email) {
  const normalizedEmail = String(email || "").trim().toLowerCase();
  const atIndex = normalizedEmail.lastIndexOf("@");
  if (atIndex <= 0 || atIndex >= normalizedEmail.length - 1) return "";
  return `@${normalizedEmail.slice(atIndex + 1)}`;
}

export function resolveCustomerEnv(customerData) {
  const envFromDomain = customerData?.environment_domain?.environment_type;
  if (envFromDomain) return String(envFromDomain).toLowerCase();
  const stageName = String(window.ENV?.STAGE_NAME || "").toLowerCase();
  return CUSTOMER_ENV_BY_STAGE[stageName] || "dev";
}

/** API uses canonical env_type from DB (e.g. `development`); resolveCustomerEnv often returns short keys (`dev`). */
function envKeyForIdpConfigMatch(v) {
  const s = String(v || "").trim().toLowerCase();
  if (!s) return "";
  if (s === "development" || s === "dev") return "dev";
  if (s === "production" || s === "prod") return "prod";
  if (s === "staging") return "dev";
  if (s === "qa" || s === "uat") return s;
  return s;
}

export function getEnvEmailDomainConfigs(customerData, currentEnv) {
  const n = envKeyForIdpConfigMatch(currentEnv);
  return (customerData?.email_domain_configs || []).filter(
    (config) => n && envKeyForIdpConfigMatch(config?.environment) === n
  );
}
